"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.LogLevel = void 0;
/**
 * Defines the severity and importance of the single log message.
 */
var LogLevel;
(function (LogLevel) {
    /**
     * Message is useful while debugging. Should only appear in a developer environment.
     * If console logged, recommended to log to `console.debug`.
     */
    LogLevel[LogLevel["Debug"] = 0] = "Debug";
    /**
     * Message notifies of state that may help troubleshoot future problems.
     * If console logged, recommended to log to `console.log`.
     */
    LogLevel[LogLevel["Info"] = 1] = "Info";
    /**
     * Message describes unexpected or bad state that was encountered, but is recoverable.
     * If console logged, recommended to log to `console.warn`.
     */
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    /**
     * Message describes unexpected or bad state that was unrecoverable.
     * If console logged, recommended to log to `console.error`.
     */
    LogLevel[LogLevel["Error"] = 3] = "Error";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
/**
 * Unique symbol reference.
 */
exports.Logger = Symbol("Logger");
//# sourceMappingURL=types.js.map